import React, { useState } from 'react';
import { Modal, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { FaLock } from 'react-icons/fa';
import { api } from '../../api';
import { useAuth } from '../../context/AuthContext';
import notify from '../ui/feedback/notify';

const ForcePasswordChange = ({ show, currentPassword }) => {
    const skipCurrentPassword = !currentPassword || !String(currentPassword).trim();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [saving, setSaving] = useState(false);
    const { setMustChangePassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword || !confirmPassword) {
            notify.error('Both fields are required');
            return;
        }
        if (newPassword !== confirmPassword) {
            notify.error('Passwords do not match');
            return;
        }
        if (newPassword.length < 8) {
            notify.error('Password must be at least 8 characters');
            return;
        }

        setSaving(true);
        try {
            const body = { new_password: newPassword };
            if (!skipCurrentPassword) {
                body.current_password = currentPassword;
            }
            await api.post('/users/change-password', body);
            setMustChangePassword(false);
        } catch (err) {
            notify.error(err.response?.data?.detail || 'Failed to change password');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            centered
            className="force-password-modal"
        >
            <Modal.Header style={{ backgroundColor: 'var(--archon-navy)', borderBottom: '1px solid rgba(100,110,130,0.3)' }}>
                <Modal.Title style={{ color: 'var(--archon-white)', fontFamily: 'Century Gothic, sans-serif' }}>
                    <FaLock className="me-2" />
                    Change Your Password
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: '#1a1d23', color: '#d0d5dd' }}>
                <Alert variant="info" className="mb-3">
                    For security, you must change your password before continuing.
                    {skipCurrentPassword && (
                        <>
                            {' '}
                            You signed in with a one-time link — enter your new password below (no current
                            password needed).
                        </>
                    )}
                </Alert>

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>New Password</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showNew ? 'text' : 'password'}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Enter new password (min 8 characters)"
                                style={{
                                    backgroundColor: 'rgba(35, 40, 48, 0.95)',
                                    color: '#d0d5dd',
                                    border: '1px solid rgba(100, 110, 130, 0.3)'
                                }}
                                autoFocus
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowNew(!showNew)}
                                tabIndex={-1}
                            >
                                {showNew ? <BsEyeSlash /> : <BsEye />}
                            </Button>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Confirm New Password</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showConfirm ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm new password"
                                style={{
                                    backgroundColor: 'rgba(35, 40, 48, 0.95)',
                                    color: '#d0d5dd',
                                    border: '1px solid rgba(100, 110, 130, 0.3)'
                                }}
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowConfirm(!showConfirm)}
                                tabIndex={-1}
                            >
                                {showConfirm ? <BsEyeSlash /> : <BsEye />}
                            </Button>
                        </InputGroup>
                    </Form.Group>

                    <Button
                        type="submit"
                        variant="primary"
                        className="w-100"
                        disabled={saving}
                    >
                        {saving ? 'Changing...' : 'Change Password & Continue'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ForcePasswordChange;
